import { meta } from '@/helpers/constants/router';
import { TERMS_AND_AGREEMENT_ROUTE, TERMS_AND_AGREEMENT_EDIT_ROUTE, } from '@/helpers/constants/GlobalRoutes';
const Wrapper = () => import('@/views/Wrapper.vue');
export default [
    {
        path: 'terms-and-agreement',
        component: Wrapper,
        redirect: TERMS_AND_AGREEMENT_ROUTE.name,
        meta: { ...meta, title: TERMS_AND_AGREEMENT_ROUTE.title },
        children: [
            {
                path: '/',
                name: TERMS_AND_AGREEMENT_ROUTE.name,
                component: () => import('@/views/v2/TermsAndAgreement.vue'),
                meta: {
                    title: TERMS_AND_AGREEMENT_ROUTE.title,
                    subtitle: 'Create your policies and terms here.',
                },
            },
            {
                path: ':uuid',
                component: Wrapper,
                meta,
                children: [
                    {
                        path: 'edit',
                        name: TERMS_AND_AGREEMENT_EDIT_ROUTE.name,
                        props: true,
                        component: () => import('@/views/v2/TermsAndAgreementEdit.vue'),
                        meta: { title: TERMS_AND_AGREEMENT_EDIT_ROUTE.title },
                    },
                ],
            },
        ],
    },
];
